(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ig-pairs-well-with"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ig-pairs')) {
    customElements.define('ig-pairs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        const load = async () => {
          try {
            const response = await fetch(this.dataset.url);
            if (!response.ok) return;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const result = html.querySelector('ig-pairs');
            if (result && result.querySelector('.ig-pairs__card')) this.replaceChildren(...result.childNodes);
          } catch {}
        };
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
          }, { rootMargin: '200px' });
          observer.observe(this);
        } else load();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
